



































































































































import Vue from 'vue'
import ResourceItemList from '@/components/ResourceItemList.vue'

import { titleize } from 'underscore.string'
import { mapState } from 'vuex';
import { firestore } from "firebase";

export default Vue.extend({
  name: "resource-page",
  components: { ResourceItemList },
  props: {
    resource: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      canEdit: false,
      fullscreen: false,
      firstVisible: null as any,
      lastVisible: null as any,
      autoRefresh: true as boolean,
      items: [] as any[],
      visibleItems: [] as any[],
      loading: true,
      menu: null,
      menus: {
        create: {
          title: "Quick Create",
          fields: []
        },
        filter: {
          title: "Filter",
          fields: {}
        },
        search: {
          title: "Search",
          value: ""
        },
        sort: {
          title: "Sort",
          field: "name",
          direction: "asc"
        }
      },
      pageScrollTop: 0,
      query: {
        limit: 12,
        orderBy: {
          field: "name",
          order: undefined
        },
      },
      scrollingDown: false,
      unsubscribe: () => null as any
    }
  },

  computed: {
    menuItems() {
      return {
        create: {
          label: "Create",
          action: "create",
          icon: "plus",
          class: "primary"
        },
        filter: {
          label: "Filter",
          action: "filter",
          icon: "filter",
          class: "link"
        },
        sort: {
          label: "Sort",
          action: "sort",
          icon: "sort",
          class: "link"
        },
        new: {
          label: "New",
          action: "new",
          icon: "plus",
          class: "link"
        }
      }
    },
    filterFields():object[] {
        const fields = Object.entries(this.schema).filter(([key, field]) => field.options != undefined)
        if (this.resource == 'views') {
          fields.push([
            'upToDate',
            this.upToDateField()
          ])
        }
        return fields
    },
    sortFields():object[] {
      const fields = Object.entries(this.schema).filter(([key, field]) => field.sortable) || []
      if (this.resource == 'views') {
        fields.push([
          'upToDate',
          this.upToDateField()
        ])
      }
      return fields
    },
    schema():any[] {
      return this["schemas"][this.resource]
    },
    ...mapState([
      "schemas"
    ])
  },

  methods: {
    clearMenus() {
      this.$set(this.menus.filter, "fields", {})
      this.$set(this.menus.sort, "field", "name")
      this.$set(this.menus.sort, "direction", "asc")
      this.$set(this.menus.search, "value", "")
    },
    pageScroll(event) {
      if (event.target.scrollTop > this.pageScrollTop) {
        this.scrollingDown = true
        this.$emit('scrollingDown', true)
      } else {
        this.scrollingDown = false
        this.$emit('scrollingDown', false)
      }
      this.pageScrollTop = event.target.scrollTop
    },
    queryString(): string {
      const params = [] as string[];

      const filters = Object.entries(this.menus.filter.fields).filter(
        ([key, value]) => typeof value !== "undefined"
      );
      if (filters.length) {
        params.push(
          "filter=" + filters.map(([key, value]) => `${key}:${value}`).join(",")
        );
      }

      const search = this.menus.search.value;
      if (search) {
        params.push(`search=${this.menus.search.value}`);
      }

      const sort = this.menus.sort.field;
      if (sort) {
        params.push(
          `sort=${this.menus.sort.field},${this.menus.sort.direction || "asc"}`
        );
      }

      return params.length ? "?" + params.join("&") : "";
    },
    async searchInput(search: string) {      
      history.pushState(
        {},
        document.title,
        this.$route.path + this.queryString()
      );
      if (search.length > 0) {
        const words = search.toLowerCase().split(";");
        const items = this.items.filter((item) => {
          return words.every(
            (string) =>
              JSON.stringify(Object.values(item))
                .toLowerCase()
                .indexOf(string.trim()) > -1
          );
        });
        this.visibleItems = items;
      }
      else
      {
        var fireBaseQuery = this.GetBaseQuery();
        // fireBaseQuery = this.ApplyLimit(fireBaseQuery);
        await this.GetData(fireBaseQuery);
      }
      this.menus.search.value = search;
      this.loading = false;
    },

    GetBaseQuery() {
      this.items = [];
      this.loading = true;
      var query:any = undefined;
      const fields = Object.entries(this.menus.filter.fields);
      const sortField:string = this.menus.sort.field;
      const sortDirection:string = this.menus.sort.direction;

      if (this.$store.state.auth.token.claims.super) {
        query = this.$db.collection(this.resource);
      } else if (this.$store.state.auth.token.claims.partner) {
        const partnerId = this.$store.state.auth.token.claims.partner;
        query = this.$db
          .collection(this.resource)
          .where("partners", "array-contains", partnerId);
      } else if (this.$store.state.auth.token.claims.client) {
        const clientId = this.$store.state.auth.token.claims.client;
        query = this.$db
          .collection(this.resource)
          .where("clients", "array-contains", clientId);
      } else {
        query = this.$db
          .collection(this.resource)
          .where("users", "array-contains", this.$store.getters.user.id);
      }
      
      if (fields.length) {
        fields.forEach((field) => {       
          query = query.where(field[0], "==", field[1]);
        });
      }

      if (sortField && fields.some(e => e[0] === sortField) === false) { 
        query = query.orderBy(sortField, sortDirection);
      }
      return query;
    },

    toggleAutoRefresh()
    {
      if(this.autoRefresh == true)
      {
        this.enableAutoRefresh();
        return;
      }
      this.disableAutoRefresh();
    },
    disableAutoRefresh()
    {
      this.unsubscribe();
    },
    enableAutoRefresh()
    {
      let timeoutId: number | undefined = undefined; // The timeout has been added to prevent the UI from going crazy
      var fireBaseQuery = this.GetBaseQuery();
       this.unsubscribe = fireBaseQuery.onSnapshot(
        (snapshot: firestore.QuerySnapshot) => {
          if (snapshot.docChanges().length) {
            clearTimeout(timeoutId); 
            timeoutId = setTimeout(() => {
              var fireBaseQuery = this.GetBaseQuery();
              this.GetData(fireBaseQuery);
            }, 1000); 
          }
          this.loading = false;
        }
      );
    },
    upToDateField() {
      return {
              label: "Up To Date?",
              options: [
                {
                  value: 0,
                  label: "Not Up To Date"
                },
                {
                  value: 1,
                  label: "Up To Date"
                }
              ],
              fieldTag: "select",
              fieldType: "option"
            }
    },
    async GetData(query)
    {
      const data = await query
      .get()
      .then((querySnapshot) => {
        const firstVisible = querySnapshot.docs[0]; 
        const lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
        if(firstVisible != null)
        {
          this.firstVisible = firstVisible;
        }
        if(lastVisible != null)
        {
          this.lastVisible = lastVisible;
        }
        querySnapshot.forEach((doc) => {
            const item: { [key: string]: any } = {
              _id: doc.id,
              ...doc.data(),
              };
            const index = this.items.findIndex((_item) => {
                 return _item._id == item._id;
               });
               if (index > -1) {
                 this.$set(this.items, index, item);
               } else {
                 this.$set(this.items, this.items.length, item);
               }
            });
          })
      .catch((error) => {     
      });
      this.visibleItems = this.items;
      this.loading = false;
    },
    async init() { 
      this.visibleItems = [];
      this.items = [];
      this.loading = true;
      const query = new URLSearchParams(decodeURI(window.location.search));
      if (query.get("filter")) {
        const filterString = query.get("filter") || "";
        const filters = filterString.split(",").forEach((filterPart) => {
          const filter = filterPart.split(":");
          if (filter.length === 2) {
            this.menus.filter.fields[filter[0]] = filter[1];
          }
        });
      } 

      this.menus.search.value = query.get("search") || "";

      if (query.get("sort")) {
        const sort = query.get("sort") || "";
        this.menus.sort.field = sort.split(",")[0];
        this.menus.sort.direction =
          sort.split(",")[1] === "asc" || sort.split(",")[1] === "desc"
            ? sort.split(",")[1]
            : this.menus.sort.direction;
      } else {
        this.menus.sort.field = "";
        this.menus.sort.direction = "asc";
      }
      this.searchInput(this.menus.search.value);
    },
  },

  watch: {
    resource() {
      this.init();
    }
  },

  filters: {

  },
  created() {
    if ((Object.keys(this.$route.query).length === 0 || this.$route.query.sort !== 'latestImageUpload,desc') && this.resource == 'views') {
      // Construct new URL with desired query parameters
      const queryParams = {
        sort: 'latestImageUpload,desc'
      };

      // Construct new URL with query parameters
      const newRoute = {
        path: this.$route.path,
        query: queryParams,
      };
      // Redirect to new URL with query parameters
      this.$router.push(newRoute);
    }
    
    const getUserResourceItems = setInterval(async () => {
      if (this.$store.state.user && this.$store.state.user.id) {
        this.canEdit = this.$store.state.auth.token.claims.super;
        this.autoRefresh = !this.$store.state.auth.token.claims.super;
        // this.updateResourceItems(this.resource, this.query)
        clearInterval(getUserResourceItems)
        await this.init();        
        if(this.autoRefresh)
        {
          this.enableAutoRefresh();
        }
      }
    }, 50)
  },
  mounted() {
    
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  updated() {

  }
})
